import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from "react";
import "../index.less";

var EvaluationNps = function EvaluationNps(props) {
  var _useState = useState(Number),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRate = _useState2[0],
      setSelectedRate = _useState2[1]; // 选中的评分
  // 评分列表


  var reteNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  var changeColor = function changeColor(item) {
    if (selectedRate >= item) {
      if (item === 7 || item === 8) {
        return "rate-div rate-div-selected2 p";
      }

      if (item === 9 || item === 10) {
        return "rate-div rate-div-selected3 p";
      }

      return "rate-div rate-div-selected1 p";
    }

    return "rate-div ";
  };

  var onSelected = function onSelected(item, key) {
    var data = {
      questionId: item.questionId,
      score: key + 1 // 类型：Number  可有字段  备注：评分

    };
    setSelectedRate(key + 1);
    props.onSelectedItem(data);
  };

  useEffect(function () {}, []); // 选择表情

  return /*#__PURE__*/React.createElement("div", {
    className: "evaluationPage"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rate-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "num-rate"
  }, reteNumber.map(function (item, key) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: changeColor(item),
      onClick: function onClick() {
        onSelected(item, key);
      }
    }, /*#__PURE__*/React.createElement("p", null, item));
  })), /*#__PURE__*/React.createElement("div", {
    className: "row-tips"
  }, /*#__PURE__*/React.createElement("span", {
    className: "row-tips-left"
  }, "\u4E0D\u613F\u63A8\u8350"), /*#__PURE__*/React.createElement("span", {
    className: "row-tips-right"
  }, "\u975E\u5E38\u63A8\u8350"))));
};

export default EvaluationNps;